import React from "react";
import { LogoutOutlined } from "@ant-design/icons";
import {
  CustomerSidebarWrapper,
  CustomerSidebarList,
  CustomerSidebarItem,
} from "./Customer.style";

export interface ICustomerSidebarItem {
  key: string;
  label: string;
}

interface ICustomerSidebarProps {
  items: ICustomerSidebarItem[];
  activeKey: string;
  onSelect: (key: string) => void;
  onLogout: () => void;
  disabled?: boolean;
}

export const CustomerSidebar: React.FC<ICustomerSidebarProps> = ({
  items,
  activeKey,
  onSelect,
  onLogout,
  disabled,
}) => (
  <CustomerSidebarWrapper>
    <CustomerSidebarList>
      {items.map((item) => (
        <CustomerSidebarItem key={item.key} active={item.key === activeKey}>
          <button
            type="button"
            onClick={() => !disabled && onSelect(item.key)}
            disabled={disabled}
          >
            {item.label}
          </button>
        </CustomerSidebarItem>
      ))}
      <CustomerSidebarItem>
        <button type="button" onClick={onLogout}>
          <LogoutOutlined />
          Έξοδος
        </button>
      </CustomerSidebarItem>
    </CustomerSidebarList>
  </CustomerSidebarWrapper>
);
